<template>
    <v-card>
        <div v-padding="3">
            <v-row>
                <v-col xs="5">
                    <v-text type="headline">Тарифный план</v-text>
                </v-col>
                <v-col xs="7">
                    <v-text type="headline">Стоимость продуктов</v-text>
                </v-col>
            </v-row>

            <v-row v-margin.top="3" v-margin.bottom="3">
                <v-col xs="4">
                    <div>
                        <tariff-card title="Тарифный план">
                            {{ tariff.title }}
                        </tariff-card>
                        <tariff-card title="Срок действия">
                            {{ numberWithSpaces(tariff.lifetime) }} {{tariff.lifetime > 1 ? 'месяца' : 'месяц'}}
                        </tariff-card>
                        <tariff-card title="Стоимость">
                            {{ numberWithSpaces(tariff.cost) }} руб.
                        </tariff-card>
                    </div>
                </v-col>
                <v-col offset-xs="1" xs="7">
                    <v-row v-margin.bottom="1" v-for="(product, index) in products" :key="index">
                        <v-col xs="10">
                            <v-text>
                                {{ product.title }}
                            </v-text>
                        </v-col>

                        <v-col xs="2" v-text-align.right>
                            <v-text nowrap> {{ product.cost }} руб. </v-text>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-form v-if="(isIdentified ? true : isFilled)" :defaultValues="defaultValues" @submit="handleSubmit"
                :validate="validateCreatePaymentForm" :readonly="isPaying">
                <template scope="api">
                    <v-row>
                        <v-col xs="6" sm="6">
                            <div>
                                <v-text bold>Оплатить с помощью</v-text>
                                <v-form-radio v-margin.top="2" :key="1" field="method" :data="'1'"
                                    :label="'Безналичный счет'" :clickEvent="changeBtnName" />
                                <v-tooltip v-if="!isIdentified"
                                    text="Для оплаты через онлайн банкинг необходимо пройти процедуру идентификации">
                                    <v-form-radio :disabled="true" v-margin.top="2" :key="2" field="method" :data="'2'"
                                        :label="'Банковская карта, СБП'" :clickEvent="changeBtnName" />
                                </v-tooltip>
                                <v-form-radio v-else v-margin.top="2" :key="2" field="method" :data="'2'"
                                    :label="'Банковская карта, СБП'" :clickEvent="changeBtnName" />
                                <v-form-radio v-margin.top="2" :key="3" field="method" :data="'3'"
                                    :disabled="(balance < tariff.cost)"
                                    :label="`Баланс (${numberWithSpaces(balance)} руб.)`" :clickEvent="changeBtnName" />
                            </div>
                        </v-col>
                    </v-row>

                    <v-row v-margin.top="3">
                        <v-col>
                            <v-form-checkbox field="isAgree" data="true">
                                <template slot="label" scope="label">
                                    <v-text>
                                        Подтверждаю согласие с
                                        <v-link pointer
                                            @click="openNewWindow('https://exbico.ru/oferta_und')">Лицензионным
                                            соглашения</v-link>
                                    </v-text>
                                </template>
                            </v-form-checkbox>
                        </v-col>
                        <v-col v-text-align.right>
                            <div>
                                <v-link v-if="(isIdentified ? false : !isFilled)" :to="'/profile'">
                                    Заполнить профиль
                                </v-link>
                                <v-spinner v-else :active="isPaying">
                                    <v-button type="submit" primary :disabled="api.isInvalid || isPaying">
                                        {{ btnName }}
                                    </v-button>
                                </v-spinner>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </v-form>
            <div v-else>
                <v-row>
                    <v-col xs="6" sm="6">
                        <div>
                            <v-text danger>Для оплаты услуг необходимо заполнить профиль</v-text>
                        </div>
                    </v-col>
                    <v-col v-text-align.right>
                        <div>
                            <v-link :to="'/profile'">
                                Заполнить профиль
                            </v-link>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <v-modal :active="isShowModal" @close="onCloseModal">
            <div v-padding="2">
                <div v-margin.bottom="2">
                    <v-text type="title"> Счет для оплаты сформирован и сохранен </v-text>
                </div>

                <v-text type="subheadling">
                    Счет всегда доступен в разделе "Финансы"
                </v-text>

                <div v-text-align.right>
                    <v-button primary flat @click="onCloseModal">
                        перейти к списку счетов
                    </v-button>
                </div>
            </div>
        </v-modal>

        <v-modal :active="isShowTariffBuyModal" @close="onCloseTariffBuyModal">
            <div v-padding="2">
                <div v-margin.bottom="2">
                    <v-text type="title"> Тариф успешно приобретен </v-text>
                </div>

                <div v-text-align.right>
                    <v-button primary flat @click="onCloseTariffBuyModal">
                        перейти к созданию запросов
                    </v-button>
                </div>
            </div>
        </v-modal>
    </v-card>
</template>
<script>
import { TariffCard } from "../tariffCard";
import { numberWithSpaces } from "../../../helpers";
import { METHODS_STRING, METHODS, BTN_NAME } from "./constants";
import { validateCreatePaymentForm } from "./validate";

export default {
    name: "tariff-buy",
    props: {
        onCreatePayment: Function,
        onBuyTariff: Function,
        hasTariff: Boolean,
        isFilled: Boolean,
        isIdentified: Boolean,
        balance: Number,
        tariff: {
            type: Object,
            default() {
                return {};
            },
        },
        products: {
            type: [Array, Object],
            default() {
                return [];
            },
        },
    },
    components: {
        TariffCard,
    },
    data() {
        return {
            error: "",
            isShowModal: false,
            isShowTariffBuyModal: false,
            methodsString: METHODS_STRING,
            isPaying: false,
            defaultValues: {
                method: this._props.isIdentified ? METHODS.Card.toString() : METHODS.Cash.toString(),
                isAgree: [],
            },
            btnName: BTN_NAME[this._props.isIdentified ? METHODS.Card : METHODS.Cash],
        };
    },
    methods: {
        validateCreatePaymentForm,

        numberWithSpaces,

        changeBtnName(id) {
            this.btnName = BTN_NAME[id];
        },

        handleBuyTariff() {
            this.isSubscribing = true;

            this.onBuyTariff(this.tariff.id)
                .then((res) => {
                    this.isSubscribing = false;
                    this.isShowTariffBuyModal = true;
                })
                .catch((res) => {
                    this.error = res.message;
                    this.isSubscribing = false;
                });
        },

        handleSubmit(values) {
            const data = { ...values, method: parseInt(values.method), tariffVersionId: this.tariff.id }
            delete data.isAgree
            if (this.isPaying) {
                return;
            }

            this.isPaying = true;

            if (values.method == METHODS.Balance) {
                this.onBuyTariff(this.tariff.id)
                    .then((res) => {
                        this.isSubscribing = false;
                        this.isShowTariffBuyModal = true;
                    })
                    .catch((res) => {
                        this.error = res.message;
                        this.isSubscribing = false;
                    });
            } else {
                this.onCreatePayment(data)
                    .then(res => {
                        this.isPaying = false;
                    })
                    .catch(res => {
                        this.isPaying = false;
                    });
            }
        },

        onCloseModal() {
            this.$router.push("/pricing");
            this.isShowModal = false;
        },
        
        openNewWindow(url) {
            window.open(url, '_blank');
        },

        onCloseTariffBuyModal() {
            this.$router.push("/");
            this.isShowModal = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// TariffBuy.vue?160edfbb